<template>
  <div>
    <div class="page_title">填写微信收款账户信息</div>
    <div class="form">
      <div class="form_row">
        <div class="label">商户号</div>
        <input class="input" placeholder="商户号" v-model="merchantId"/>
      </div>
      <div class="form_row">
        <div class="label">商户ID</div>
        <input class="input" placeholder="商户ID" v-model="partnerId" disabled/>
      </div>
      <div class="form_row">
        <div class="label">证书编号</div>
        <input class="input" placeholder="证书编号" v-model="merchantSn"/>
      </div>
      <div class="form_row">
        <div class="label">APIV3Key</div>
        <input class="input" placeholder="APIV3Key" v-model="merchantApiv3key"/>
      </div>
      <div class="form_row">
        <div class="label">私钥</div>
        <textarea class="textarea" v-model="merchantPrivateKey">
        </textarea>
      </div>

    </div>
    <div class="button_grounp">
      <button class="button cancel" @click="cancel">取消</button>
      <button class="button confirm" @click="confirmEdit">确认</button>
    </div>
  </div>
</template>

<script>
import { addWePayMerchant } from '../api';
export default {
  name: "apply_cashier",
  data(){
    return {
      merchantId: '',
      partnerId: sessionStorage.getItem('partnerid'),
      merchantSn: '',
      merchantApiv3key: '',
      merchantPrivateKey: ''
    }
  },
  methods: {
    // 取消
    cancel(){
      this.$router.go(-1)
    },

    // 确认修改
    confirmEdit(){
      console.log('确认修改');
      let params = {
        merchantId: this.merchantId,
        partnerId: this.partnerId,
        merchantSn: this.merchantSn,
        merchantApiv3key: this.merchantApiv3key,
        merchantPrivateKey: this.merchantPrivateKey
      }
      addWePayMerchant(params).then(res => {
        if(res.data.retcode == 0){
          alert('新增成功');
          this.$router.go(-1)
        }else{
          alert(`异常${res.data.retmsg}`)
        }
      }).catch(error => {
        alert(`异常${error}`)
      })
    }
  }
}
</script>

<style src="../css/apply_cashier.css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/apply_cashier.vue